module.exports = __webpack_public_path__ + "img/1.0bb56b0f.jpg";